/**
 * Created by alex.y on 9/25/2017.
 */
import {Directive, forwardRef, Input} from '@angular/core';
import {Validator, AbstractControl, NG_VALIDATORS} from '@angular/forms';
import {Location} from "../../../objects/management/locationManagement/location";
import {ExtraDataService} from "../../../services/extraDataService";
import {LocationType} from "../../../objects/management/locationManagement/locationType";

@Directive({
    selector: '[validateLocationManagement][ngControl],[validateLocationManagement][ngFormControl],[validateLocationManagement][ngModel]',
    providers: [
        {provide: NG_VALIDATORS, useExisting: forwardRef(() => ManagementLocationValidatorDirective), multi: true}
    ]
})
export class ManagementLocationValidatorDirective implements Validator {
    @Input('validateLocationManagement') location: Location;
    @Input() originalLocation: Location;
    @Input() locationType: number;
    constructor() {
    }

    private onChange: () => void;

    validate(control: AbstractControl): { [key: string]: any } {
        if (!this.location)
            return {validateLocationManagement: false};

        if (!this.location || (!this.location.Country))
            return {validateLocationManagement: false};

        if(this.originalLocation != null && !String.isNullOrEmpty(this.originalLocation.Country) && this.originalLocation.Country.toLowerCase() != this.location.Country.toLowerCase()) {
            return {validateChangeCountry: false};
        }

        if(this.locationType == 2){
            if ( this.location.Country.toLowerCase() == 'canada' && !this.location.State)
                return {validateLocationManagement: false};

            if ((!this.location.Country.match(/.*(Canada|USA|United States).*/i)))
                return {validateLocationManagement: false};

            return null;
        }

        if(this.locationType == 3 || this.locationType == 4){
            if ((!this.location.Country || !this.location.City || !this.location.Street))
                return { validateLocationManagement: false };
        }

        return null;
    }

}


// WEBPACK FOOTER //
// ./app/common/directives/validators/managementLocationValidator.ts